import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const namespaced = true

const state = {
  index: {
    rows: {},
    children: {},
    ids: [] // holds order or items
  },
  editing: {
    rows: {},
    children: {},
    ids: [] // holds order or items
  },
  modals: {
    move: {
      visible: false,
      id: null
    },
    mediaLibrary: {
      visible: false
    },
    imageCrop: {
      visible: false
    }
  },
  fetching: false,
  saving: false,
  hasApiErrors: false,
  apiRequestOrder: [] // allows mapping of response error to items
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/items/index.js